import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DISPLAY_DATE_FORMAT, IconNames, S_CODE_ICONS, SCode } from '../../common/constants';
import { LoadStatus } from '../../store/state/shipment-load';
import { StatusAcceptanceType } from '../../store/constants';

@Component({
  selector: 'ui-load-tracking-graph',
  templateUrl: './load-tracking-graph.component.html',
  styleUrls: ['./load-tracking-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadTrackingGraphComponent {
  @Input() set loadStatuses(statuses: LoadStatus[]) {
    this.statuses = [...statuses].reduce(
      (accum: LoadStatus[], current: LoadStatus, index: number, arr: LoadStatus[]) => {
        const result = { ...current };
        result.hide =
          result.acceptanceType === StatusAcceptanceType.NotReceived ||
          result.acceptanceType === StatusAcceptanceType.Current ||
          (Boolean(arr[index + 1]) && arr[index + 1].acceptanceType === StatusAcceptanceType.NotReceived);
        accum.push(result);
        return accum;
      },
      [],
    );
  }

  statuses: LoadStatus[];
  acceptanceType = StatusAcceptanceType;
  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  dateFormat = DISPLAY_DATE_FORMAT;
}
